import createSpacing from '@material-ui/core/styles/createSpacing';

export const spacing = createSpacing(8);
